import NextLink from 'next/link'
import React from 'react'

import Img from './Image'

export interface iBannerProps {
  link: string
  image: string
  id: string
}
const Banner: React.FC<iBannerProps> = ({ link, image, id }) => {
  return (
    <NextLink href={`/assinar/lead?origin=${id}`} passHref legacyBehavior>
      <Img
        alt={`Banner-${id}`}
        data-cy={`Banner-${id}`}
        style={{ cursor: 'pointer' }}
        layout="fill"
        objectFit="contain"
        src={image}
        priority
        quality={80}
      />
    </NextLink>
  )
}

export default Banner
